export const largeImageUrl = (url) => url.replace('cms/', 'cms/large_');
export const mediumImageUrl = (url) => url.replace('cms/', 'cms/medium_');
export const smallImageUrl = (url) => url.replace('cms/', 'cms/small_');
export const thumbnailImageUrl = (url) => url.replace('cms/', 'cms/thumbnail_');

